// extracted by mini-css-extract-plugin
module.exports = {"title3":"style__title3__x7DL4","title4":"style__title4__rcTE3","block":"style__block__oQYzs"};